import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    sencond: "Số giây mỗi lượt",
    numOfBall: "Số lượng của tất cả vật thể",
    speed: "Tốc độ rơi",
    bomRate: "Tỉ lệ (%) bom và dân theo VIP"
}

const SetupGameplay = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [vipNew, setVipNew] = useState();
    const [vipSilver, setVipSilver] = useState();
    const [vipPlatinum, setVipPlatinum] = useState();
    const [vipSappphire, setVipSappphire] = useState();

    const [turnDuration, setTurnDuration] = useState();
    const [totalSymbols, setTotaSymbols] = useState();
    const [fallSpeed, setFallSpeed] = useState();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                turnDuration: data?.turnDuration,
                totalSymbols: data?.totalSymbols,
                fallSpeed: data?.fallSpeed,
                vipNew: data?.vipLevels["NEW"],
                vipSilver: data?.vipLevels["SILVER"],
                vipPlatinum: data?.vipLevels["PLATINUM"],
                vipSappphire: data?.vipLevels["SAPPHIRE"]
            });

            setVipNew(data?.vipLevels["NEW"]?.BOMB_RATE);
            setVipSilver(data?.vipLevels["SILVER"]?.BOMB_RATE);
            setVipPlatinum(data?.vipLevels["PLATINUM"]?.BOMB_RATE);
            setVipSappphire(data?.vipLevels["SAPPHIRE"]?.BOMB_RATE);
            setTurnDuration(data?.turnDuration);
            setTotaSymbols(data?.totalSymbols);
            setFallSpeed(data?.fallSpeed);
        } catch (err) {
            console.log(err);
        }
    };

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setTurnDuration(e); return;
            case 2: setTotaSymbols(e); return;
            case 3: setFallSpeed(e); return;
            case 4: setVipNew(e/100); return;
            case 5: setVipSilver(e/100); return;
            case 6: setVipPlatinum(e/100); return;
            case 7: setVipSappphire(e/100); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            if (
                !validNumber(turnDuration) || !validNumber(totalSymbols) || !validNumber(fallSpeed)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }
            setIsShowModalSuccess(true);
            const body = {
                config: {
                    turnDuration: turnDuration ? turnDuration : configGame?.turnDuration,
                    totalSymbols: totalSymbols ? totalSymbols : configGame?.totalSymbols,
                    fallSpeed: fallSpeed? fallSpeed : configGame?.fallSpeed,
                    vipLevels: {
                        NEW: vipNew ? 
                            { MAX_SCORE: configGame?.vipNew.MAX_SCORE, BOMB_RATE: vipNew, PERSON_RATE: vipNew } : 
                            configGame?.vipNew,
                        NORMAL: vipNew ? 
                            { MAX_SCORE: configGame?.vipNew.MAX_SCORE, BOMB_RATE: vipNew, PERSON_RATE: vipNew } : 
                            configGame?.vipNew,
                        COPPER: vipNew ? 
                            { MAX_SCORE: configGame?.vipNew.MAX_SCORE, BOMB_RATE: vipNew, PERSON_RATE: vipNew } : 
                            configGame?.vipNew,
                        SILVER: vipSilver ? 
                            { MAX_SCORE: configGame?.vipSilver.MAX_SCORE, BOMB_RATE: vipSilver, PERSON_RATE: vipSilver } : 
                            configGame?.vipSilver,
                        GOLD: vipSilver ? 
                            { MAX_SCORE: configGame?.vipSilver.MAX_SCORE, BOMB_RATE: vipSilver, PERSON_RATE: vipSilver } : 
                            configGame?.vipSilver,
                        PLATINUM: vipPlatinum ? 
                            { MAX_SCORE: configGame?.vipPlatinum.MAX_SCORE, BOMB_RATE: vipPlatinum, PERSON_RATE: vipPlatinum } : 
                            configGame?.vipPlatinum,
                        EMERALD: vipPlatinum ? 
                            { MAX_SCORE: configGame?.vipPlatinum.MAX_SCORE, BOMB_RATE: vipPlatinum, PERSON_RATE: vipPlatinum } : 
                            configGame?.vipPlatinum,
                        SAPPHIRE: vipSappphire ? 
                            { MAX_SCORE: configGame?.vipSappphire.MAX_SCORE, BOMB_RATE: vipSappphire, PERSON_RATE: vipSappphire } : 
                            configGame?.vipSappphire,
                        DIAMOND: vipSappphire ? 
                            { MAX_SCORE: configGame?.vipSappphire.MAX_SCORE, BOMB_RATE: vipSappphire, PERSON_RATE: vipSappphire } : 
                            configGame?.vipSappphire,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number > 0;
    }

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };


    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumer = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[40%] justify-end mr-10">{label}:</div>
                <div className="w-[40%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        defaultValue={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={1}
                    />
                </div>
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {configGame && renderInputNumer(
                                    "new",
                                    (configGame?.vipNew?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 4), 
                                    100, `${TEXT.bomRate} NEW - COPPER`,
                                )}

                                {configGame && renderInputNumer(
                                    "silver",
                                    (configGame?.vipSilver?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 5), 
                                    100, `${TEXT.bomRate} SILVER - GOLD`,
                                )}

                                {configGame && renderInputNumer(
                                    "platinum",
                                    (configGame?.vipPlatinum?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 6), 
                                    100, `${TEXT.bomRate} PLATINUM - EMERALD`,
                                )}

                                {configGame && renderInputNumer(
                                    "sapphire",
                                    (configGame?.vipSappphire?.BOMB_RATE * 100), 
                                    (e) => handleChangeInput(e, 7), 
                                    100, `${TEXT.bomRate} SAPPHIRE - DIAMOND`,
                                )}

                                {configGame && renderInputNumer(
                                    "turnDuration",
                                    configGame?.turnDuration, 
                                    (e) => handleChangeInput(e, 1), 
                                    500, `${TEXT.sencond}`
                                )}

                                {renderInputNumer(
                                    "totalSymbols",
                                    configGame?.totalSymbols, 
                                    (e) => handleChangeInput(e, 2), 
                                    500, `${TEXT.numOfBall}`
                                )}

                                {renderInputNumer(
                                    "fallSpeed",
                                    configGame?.fallSpeed, 
                                    (e) => handleChangeInput(e, 3), 
                                    50000, `${TEXT.speed}`
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupGameplay;
